import { React, useState } from 'react'
import styles from './LineChart.module.scss'
import Select from 'react-select'
import Highcharts from 'highcharts'
import Spinner from '../../../components/Loader/Spinner'
import { components } from 'react-select'
import { Checkbox, FormField } from '@better-ui/react'
import IDPChart from '../../../components/IDPCharts/IDPChart'
import getLineChartOptions from '../../../components/LineAreaChart/areaChartOptionsAqi'
import moment from 'moment'
import TrendsCount from './TrendsCountAqi'
import getNumberFromString from '../../../utils/getNumberFromString'
import getStringFromNumberString from '../../../utils/getStringFromNumberString'

const PollutantLineChartCompare = ({filter,
    chartData,dataCategory}) => { 
  const [selectedOptions, setSelectedOptions] = useState([dataCategory[0]])
  const [selectSeasonComma, setSelectSeasonComma] = useState(dataCategory[0].label)
let season_arr=selectSeasonComma.split(',')
let chartColors=['#15A796','#C72887','#8061BC','#E4780C','#1E82CB']
let linecharttest=[]
function getSeasonData(chartData){
    let seasonarr=[]
   for(let j=0;j<season_arr.length;j++)
   {
    for(let i=0;i<chartData.length;i++)
    {
       
        if(chartData[i].season===season_arr[j])
        {
        let chartJson=(chartData[i].json_value)
        const dd=chartJson.map((chartval)=>{
          return([moment.utc(chartval.x).format('YYYY-MM-DD'), chartval.y<=-1?0:chartval.y])
        })
        let startPoint=0
        if(filter===1 && dd.length>10)
          {
            startPoint=dd.length-10*7
          }
        else if(filter===2 && dd.length>24)
          {
            startPoint=dd.length-24*7
          }
        else if(filter===3 && dd.length>=52) {
          startPoint=0
        }
        for(var s=startPoint;s<dd.length;s++)
        {
          seasonarr.push(chartData[i].json_value[s])
            //seasonarr.push([new Date(chartJson[s][0]).getTime(), chartJson[s][1]])
        }
        let obj1={
            name: chartData[i].season,
            data:seasonarr,
            dashStyle: 'solid',
            color: chartColors[i],
            visible: true,
            showInLegend: true,
          }
          seasonarr=[]
          linecharttest.push(obj1)
        } 
    }
    }
    return []
}  
    const lineChartData = [
        
        {
          name: 'Overall',
          data:getSeasonData(chartData),
          dashStyle: 'solid',
          color: Highcharts.getOptions().colors[9],
          visible: true,
          showInLegend: true,
        },
      ]
      const lineOptions = getLineChartOptions(
        linecharttest,
        'POLLUTANT',
      )
       //// Start here
  const Option = (props) => {  
    const text =
      'Select up to 5 to compare.'
    let disabled = false
    if (selectedOptions.length >= 5 && !props.isSelected) {
      disabled = true
    }
    return (
      <div>
        {props.label === dataCategory[0].label? (
          <div
            style={{ padding: '10px 10px', color: '#4B4D4F', fontSize: '14px' }}
          >
            {text}
          </div>
        ) : (
          ''
        )}
        
        <components.Option {...props}>
          <FormField disabled={disabled}>
            <Checkbox checked={props.isSelected}> {getStringFromNumberString(props.label)}<sub>{getNumberFromString(props.label)}</sub></Checkbox>
          </FormField>
        </components.Option>
      </div>
    )
   
  }
  ////End here

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: 'white',
      borderRadius: '4px',
      border: '1px solid #4B4D4F',
      boxSizing: 'border-box',
      cursor: 'pointer',
    }),
    option: (base, state) => ({
      ...base,
      color: '#1e2022',
      backgroundColor: 'white',
      padding: '.5rem 3rem .5rem .5rem',
      cursor: 'pointer',
      fontWeight: state.isSelected ? 'bold' : '',
    }),
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: '#002677',
        color: 'white',
        borderRadius: '100px',
        cursor: 'pointer',
        padding: '0px 0px 0px 5px',
      }
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: 'white',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1
      const transition = 'opacity 300ms'

      return { ...provided, opacity, transition }
    },
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: 'white',
      backgroundColor: '#002677',
      borderRadius: '100px',
      width: '32px',

      '&:hover': {
        backgroundColor: '#002677',
        color: 'white',
        borderRadius: '100px',
      },
    }),
  }
  
  function tabsChangeHandlerNew(e) {
    if (e.length <= 5) {
      setSelectedOptions(e)
     let valu=''
      e.map((dd)=>{
        if(valu==='')
        {
          valu+=dd.label
        }
        else
        {
          valu+=","+dd.label
        }
      })
      setSelectSeasonComma(valu)
    }
  }
  return (
    <div className={styles.base}>
      <div className={styles.maindivFormat}>
        <div style={{ display: 'flex' }}>
          <div style={{ width: '100%' }}>
            {/* <span className={styles.captionFormat}>Pollutants Trends {filter}</span> */}
          </div>
          <div
            style={{
              minWidth: '20%',
              maxWidth: '40%',
              marginLeft: '40%',
              marginBottom: '24px',
              borderRadius: '4px',
              //border: '1px solid #4B4D4F',
              boxSizing: 'border-box',
              width: '100%',
              marginRight: '1.5%',
              marginTop: '1px',
              cursor: 'pointer',
            }}
          >
            <Select
              isMulti
              options={dataCategory}
              onChange={tabsChangeHandlerNew}
              value={selectedOptions}
              placeholder={`Compare`}
              styles={colourStyles}
              components={{
                Option,
              }}
              hideSelectedOptions={false}
              closeMenuOnSelect={false}
            />
          </div>
        
        </div>
      </div>
       <div id="pollutant" className={styles.maindivFormat} style={{overflowY:'hidden',overflowX:filter===1?'hidden':'scroll'}} >
        <div style={{display:filter===1?'block':'none'}}>
          {lineOptions ? (
            <>
            <IDPChart
           
            chartOptions={lineOptions}
            height={'360px'}
            width={'100%'}
          />
          <TrendsCount data={lineOptions} filter={filter}/>
          </>
          ) : (
            <Spinner />
          )}
        </div>
        <div  style={{display:filter===2?'block':'none'}}>
          {lineOptions ? (
            <>
            <IDPChart
            id={'pollutant'}
            chartOptions={lineOptions}
            height={'360px'}
            width={'200%'}
          />
          <TrendsCount data={lineOptions} filter={filter}/>
          </>
          ) : (
            <Spinner />
          )}
        </div>
       
        <div  style={{display:filter===3?'block':'none'}}>
          {lineOptions ? (
             <>
            <IDPChart
            chartOptions={lineOptions}
            height={'360px'}
            width={'420%'}
          />
          <TrendsCount data={lineOptions} filter={filter}/>
          </>
          ) : (
            <Spinner />
          )}
        </div>
       
       
      </div>
      <div style={{width:'100%'}}>
          <div style={{display:'flex',fontFamily:'Optum Sans',fontSize:'12px',fontWeight:'400', justifyContent: 'center',paddingTop:'5px'}}>
            <div style={{display:'flex',marginLeft:'10px'}}>
              <div style={{borderRadius:'50%',width:'15px',height:'15px',
              backgroundColor:'#6CB2A2',border:'2px solid black',marginTop:'2px'}}></div>
               <span style={{marginLeft:'5px',fontWeight:'700'}}>0-50</span>
              <span style={{marginLeft:'10px'}}>Good</span>
            </div>
            <div style={{display:'flex',marginLeft:'10px'}}>
              <div style={{borderRadius:'50%',width:'15px',height:'15px',
              backgroundColor:'#FFFFF0',border:'2px solid black',marginTop:'2px'}}></div>
               <span style={{marginLeft:'5px',fontWeight:'700'}}>51-100</span>
              <span style={{marginLeft:'10px'}}>Moderate</span>
            </div>
            <div style={{display:'flex',marginLeft:'10px'}}>
              <div style={{borderRadius:'50%',width:'15px',height:'15px',
              backgroundColor:'#FFA977',border:'2px solid black',marginTop:'2px'}}></div>
               <span style={{marginLeft:'5px',fontWeight:'700'}}>101-150</span>
              <span style={{marginLeft:'10px'}}>Unhealthy for Sensitive Groups</span>
            </div>
            <div style={{display:'flex',marginLeft:'10px'}}>
              <div style={{borderRadius:'50%',width:'15px',height:'15px',
              backgroundColor:'#FC7261',border:'2px solid black',marginTop:'2px'}}></div>
               <span style={{marginLeft:'5px',fontWeight:'700'}}>151-200</span>
              <span style={{marginLeft:'10px'}}>Unhealthy</span>
            </div>
            <div style={{display:'flex',marginLeft:'10px'}}>
              <div style={{borderRadius:'50%',width:'15px',height:'15px',
              backgroundColor:'#F03028',border:'2px solid black',marginTop:'2px'}}></div>
               <span style={{marginLeft:'5px',fontWeight:'700'}}>201-300</span>
              <span style={{marginLeft:'10px'}}>Very Unhealthy</span>
            </div>
            <div style={{display:'flex',marginLeft:'10px'}}>
              <div style={{borderRadius:'50%',width:'15px',height:'15px',
              backgroundColor:'#C40000',border:'2px solid black',marginTop:'2px'}}></div>
              <span style={{marginLeft:'5px',fontWeight:'700'}}>&gt;300</span>
              <span style={{marginLeft:'10px'}}>Hazardous</span>
            </div>
          </div>
          </div>
    </div>
  )
}

export default PollutantLineChartCompare
